import { Component, OnInit, DebugElement } from '@angular/core';

@Component({
  selector: 'app-hil-product-authentication',
  templateUrl: './hil-product-authentication.component.html',
  styleUrls: ['./hil-product-authentication.component.css']
})
export class HilProductAuthenticationComponent implements OnInit {
  isModalShown:boolean
  constructor() {
    this.isModalShown=true
   }

  ngOnInit() {
    this.isModalShown = true;
  }

  onHidden(){
    
    this.isModalShown=false
  }

}
